


























import Vue from 'vue';
import PlaylistStudentThumbnail from '@/web/components/playlists/PlaylistStudentThumbnail';

export default Vue.extend({
  name: 'PlaylistsPanelStudentItemCard',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
      required: true,
    },
    index: {
      type: Number,
    },
    active: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  components: {
    PlaylistStudentThumbnail,
  },
  computed: {
    instructors() {
      const instructorsArray = [];
      this.playlist.content.forEach(item => {
        if (item.instructor) {
          instructorsArray.push(item.instructor);
        }
      });
      return instructorsArray;
    },
  },
});
